/* TWRD Upcoming: small helpers for sections/twrd-upcoming.liquid.
   1. Opening "Sign me up" focuses the email field.
   2. Count-up: the real sign-up counts (rendered by Liquid) count up from
      0 when the section scrolls into view. Reduced motion shows the number
      as is. After a successful sign-up the shown numbers go up by 1.
   3. After a post, Shopify reloads with the form id as the hash
      (#twrd-up-<handle>). The posted state is page-wide in Liquid, so this
      file shows the success or error line on the card the hash names,
      opens that card, and hides the section-level fallback line. */
(function () {
  'use strict';

  function bindToggles(root) {
    var notes = root.querySelectorAll('[data-twrd-up-notify]');
    Array.prototype.forEach.call(notes, function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        var input = details.querySelector('input[type="email"]');
        if (input) input.focus({ preventScroll: true });
      });
    });
  }

  function showPostedState(root) {
    var hash = (window.location.hash || '').replace('#', '');
    if (hash.indexOf('twrd-up-') !== 0) return;

    var card = root.querySelector('[data-twrd-up-card="' + hash.replace(/"/g, '') + '"]');
    if (!card) return;

    var success = card.querySelector('[data-twrd-up-success]');
    var error = card.querySelector('[data-twrd-up-error]');
    var status = root.querySelector('[data-twrd-up-status]');

    if (error) {
      error.hidden = false;
      var details = card.querySelector('[data-twrd-up-notify]');
      if (details) details.open = true;
    } else if (success) {
      success.hidden = false;
      card.classList.add('is-done');
      // The visitor just joined, so the shown counts go up by one.
      bump(root.querySelector('[data-twrd-up-proof] [data-twrd-up-num]'));
      bump(card.querySelector('[data-twrd-up-piece] [data-twrd-up-num]'));
    } else {
      return;
    }
    if (status) status.hidden = true;

    // Bring the card into the row's view, then the section into the page's view.
    var track = card.parentElement;
    if (track && typeof track.scrollTo === 'function') {
      track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'instant' });
    }
    root.scrollIntoView({ block: 'start' });
  }

  function target(el) {
    var n = parseInt(el.getAttribute('data-target'), 10);
    return isNaN(n) ? 0 : n;
  }

  function bump(el) {
    if (!el) return;
    var n = target(el) + 1;
    el.setAttribute('data-target', String(n));
    if (el.getAttribute('data-counted') === 'true') el.textContent = String(n);
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function countUp(el) {
    var end = target(el);
    var duration = 1200;
    var t0 = null;
    function frame(now) {
      if (t0 === null) t0 = now;
      var k = Math.min(1, (now - t0) / duration);
      var eased = 1 - Math.pow(1 - k, 3);
      el.textContent = String(Math.round(end * eased));
      if (k < 1) {
        window.requestAnimationFrame(frame);
      } else {
        el.textContent = String(target(el));
        el.setAttribute('data-counted', 'true');
      }
    }
    window.requestAnimationFrame(frame);
  }

  function bindCounters(root) {
    var nums = root.querySelectorAll('[data-twrd-up-num]');
    if (!nums.length) return;
    if (reducedMotion() || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nums, function (el) {
        el.textContent = String(target(el));
        el.setAttribute('data-counted', 'true');
      });
      return;
    }
    Array.prototype.forEach.call(nums, function (el) {
      el.textContent = '0';
    });
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          countUp(entry.target);
        });
      },
      { threshold: 0.6 }
    );
    Array.prototype.forEach.call(nums, function (el) {
      io.observe(el);
    });
  }

  function start() {
    var sections = document.querySelectorAll('[data-twrd-upcoming]');
    Array.prototype.forEach.call(sections, function (root) {
      bindToggles(root);
      bindCounters(root);
      showPostedState(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
